import { axiosClient } from "../lib/axiosClient";

export interface RegisterData {
    registrationType: string;
    fullName: string;
    email: string;
    password: string;
    password_confirmation: string;
    phone: string;
    institution: string;
    position?: string;
    gender?: string;
    blood_type?: string;
    clothing_size?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    agreeToTerms: boolean;
}

export const registerUser = async (data: RegisterData) => {
    const response = await axiosClient.post("/register", data);
    return response.data;
};
